import { render, staticRenderFns } from "./MA9.vue?vue&type=template&id=5daad756&scoped=true&"
import script from "./MA9.vue?vue&type=script&lang=js&"
export * from "./MA9.vue?vue&type=script&lang=js&"
import style0 from "./MA9.vue?vue&type=style&index=0&id=5daad756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daad756",
  null
  
)

export default component.exports